<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-account-cancel</v-icon>
        <span class="config-section-label">Contas bloqueadas</span>
        <v-chip v-if="contas_bloqueadas && contas_bloqueadas.length" x-small class="ml-2" color="surface_tertiary">
          {{ contas_bloqueadas.length }}
        </v-chip>
      </div>
      <ModalAdicionarOuEditarContaBloqueada
        :getContasBloqueadas="fetch"
      />
    </div>

    <!-- Table -->
    <DataTables
      v-if="contas_bloqueadas && contas_bloqueadas.length > 0"
      :data="contas_bloqueadas"
      :headers="headers"
      :itens-por-pagina="5"
      :fetchData="fetch"
      tab="contas"
      class="contas-table"
    />

    <!-- Empty state -->
    <div v-if="contas_bloqueadas && contas_bloqueadas.length === 0" class="sc-empty-state">
      <v-icon size="40" color="text_secondary" class="mb-3">mdi-account-check-outline</v-icon>
      <span class="sc-empty-state__title">Nenhuma conta bloqueada</span>
      <span class="sc-empty-state__subtitle">Adicione contas para filtrar colaborações indesejadas</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalAdicionarOuEditarContaBloqueada from "../../ContaBloqueada/ModalAdicionarOuEditarContaBloqueada.vue";
import DataTables from "@/components/DataTables.vue";

export default {
  name: "ConfigTabContasBloqueadas",
  components: { ModalAdicionarOuEditarContaBloqueada, DataTables },
  props: {
    codProducao: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  watch: {
    active: {
      immediate: true,
      handler(isActive) {
        if (isActive) this.fetch();
      },
    },
    codProducao() {
      if (this.active) this.fetch();
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Conta",
          align: "start",
          sortable: false,
          name: "dsc_colaborador_user",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Fonte",
          align: "start",
          sortable: false,
          name: "dsc_fonte_colaboracao",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold pr-15",
          value: "name",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      contas_bloqueadas: "contas_bloqueadas/getterContasBloqueadas",
    }),
  },
  methods: {
    ...mapActions({
      getContasBloqueadas: "contas_bloqueadas/getContasBloqueadas",
    }),
    async fetch() {
      await this.getContasBloqueadas({ cod_producao: this.codProducao });
    },
  },
};
</script>

<style lang="scss" scoped>
.contas-table {
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
}

::v-deep .contas-table tbody td {
  height: 72px !important;
}

</style>
